import { Context } from '@silvertours/front-legacy-shared';

const { useClientContext } = Context;
const hasContext: Context.AssertHasContext = Context.guardContext;

type NewsletterContext = {
  baseUrl: string;
};

const join = (baseUrl: string, path: string) => {
  const delimiter = path.startsWith('/') ? '' : '/';

  return `${baseUrl}${delimiter}${path}`;
};

const useNewsletter = () => {
  const result = useClientContext<NewsletterContext>('newsletter');

  hasContext<NewsletterContext>('newsletter', result);

  const { baseUrl } = result.value;

  return {
    formatApiUrl(path: string) {
      return join(baseUrl, path);
    },
  };
};

export { useNewsletter };
export type { NewsletterContext };
